var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.5C10.8656 0.5 14 3.63437 14 7.5C14 11.3656 10.8656 14.5 7 14.5C3.13437 14.5 3.22196e-08 11.3656 0 7.5C0 3.63437 3.13437 0.5 7 0.5ZM7 1.5C3.6875 1.5 1 4.1875 1 7.5C1 10.8125 3.6875 13.5 7 13.5C10.3125 13.5 13 10.8125 13 7.5C13 4.1875 10.3125 1.5 7 1.5ZM8 6.5V10.5H9V11.5H5V10.5H6V7.5H5V6.5H8ZM8 5.5H6V3.5H8V5.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsIcon);
export default __webpack_public_path__ + "static/media/detailsIcon.222573755a8d41bd83ebe7ead0749232.svg";
export { ForwardRef as ReactComponent };